module.exports = __webpack_public_path__ + "img/image13@2x.ba4694bc.png";